export default __webpack_public_path__ + "static/media/11.674bf084.jpeg";